@import "../../variables.scss";

.readingList {
  @media (max-width: $size-md) {
    order: 1;
  }
}

.readingList__wrapper {
  width: 96%;
  @media (max-width: $size-md) {
    width: 100%;
    box-shadow: none !important;
  }
}

.readingList__wrapperGB {
  width: 100%;
  @media (max-width: $size-md) {
    box-shadow: none !important;
  }
}

.sectionContainer {
  display: flex;
  flex-direction: row;
  @media (max-width: $size-md) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.submitButtonDesktop {
  width: 60%;
  display: flex;
  text-align: start;
  margin-right: 1.5rem;
}

@media only screen and (max-width: 576px) {
  .submitButtonDesktop {
    visibility: hidden;
    height: 0;
    width: 0;
    margin: 0;
  }
}

.column1 {
  flex: 1;
}

.column2 {
  flex: 1;
}
